package org.gstechnovos.jexonplastech.sections.footer

import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.before
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val FooterLinkStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.color(palette.custom.darkText).transition(Transition.of("color", 0.2.s))
    }
    hover {
        Modifier.color(palette.brand.primaryBlue)
    }
}

val KnowMoreLinkStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.position(Position.Relative).color(palette.brand.primaryBlue).transition(Transition.of("color", 0.3.s))
    }
    before {
        Modifier.content("").position(Position.Absolute).bottom((-4).px)
            .left(0.px).width(0.px)
            .height(2.px).backgroundColor(palette.brand.primaryBlueHover)
            .transition(Transition.of("width", 0.3.s, TransitionTimingFunction.EaseOut))
    }
    hover {
        Modifier.color(palette.brand.primaryBlueHover)
    }
    cssRule(":hover::before") {
        Modifier.width(100.percent)
    }
}

// FIXED: Clean Kobweb modifiers locking down color and translation
val AnimatedFooterLinkStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .color(palette.custom.darkText)
            .textDecorationLine(TextDecorationLine.None)
            .transition(
                Transition.of("color", 0.2.s, TransitionTimingFunction.EaseInOut),
                Transition.of("transform", 0.2.s, TransitionTimingFunction.EaseOut)
            )
    }
    hover {
        Modifier
            .color(palette.brand.primaryBlue)
            .textDecorationLine(TextDecorationLine.None)
            .translateX(4.px)
    }
}

val SocialIconStyle = CssStyle {
    base {
        Modifier
            .size(24.px)
            .transition(Transition.of("transform", 0.2.s), Transition.of("filter", 0.2.s))
            .styleModifier { property("filter", "grayscale(100%)") }
    }
    hover {
        Modifier
            .scale(1.1)
            .styleModifier { property("filter", "grayscale(0%)") }
    }
}